var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomRight"}},[_vm._l((_vm.selectPage),function(item){return _c('div',{key:item.value,class:item.is_selected ? ['isselect'] : ['noselect'],on:{"click":function($event){return _vm.selectitem(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),_c('bottomRightChart',{ref:"bottomRightChart"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }